import { useIntl } from 'react-intl';

import { FontSizes, FontWeights, Text } from '@calm-web/design-system';

import Image from '@/components/image/NextImage';

import {
	Column,
	FeatureContainer,
	FeatureIconWrapper,
	FeatureImageWrapper,
	FeatureInfoContainer,
} from './styles';
import { Feature } from './types';

const Features = ({ icon: Icon, label, body, image }: Feature) => {
	const { formatMessage } = useIntl();
	return (
		<FeatureContainer>
			<Column>
				<FeatureInfoContainer>
					<FeatureIconWrapper>
						<Icon height="80px" width="80px" />
					</FeatureIconWrapper>
					<Text size={FontSizes.lg} el="h3" align="center" weight={FontWeights.Medium}>
						{formatMessage(label)}
					</Text>
					<Text size={FontSizes.base} align="center" el="p" noMargin>
						{formatMessage(body)}
					</Text>
				</FeatureInfoContainer>
			</Column>
			<Column>
				<FeatureImageWrapper>
					{image ? (
						<Image
							alt=""
							src={image}
							width={355}
							height={500}
							style={{ width: '100%', height: 'auto', objectFit: 'cover' }}
						/>
					) : null}
				</FeatureImageWrapper>
			</Column>
		</FeatureContainer>
	);
};

export default Features;
